/**
 * OSRM route geometry for map polylines.
 * Override base URL in production via REACT_APP_OSRM_URL.
 */
const OSRM_API =
  process.env.REACT_APP_OSRM_URL || 'https://router.project-osrm.org/route/v1/driving';

export async function fetchOsrmRoute(startLat, startLng, endLat, endLng) {
  try {
    const url = `${OSRM_API}/${startLng},${startLat};${endLng},${endLat}?overview=full&geometries=geojson`;
    const response = await fetch(url);
    const data = await response.json();

    if (data.code === 'Ok' && data.routes?.length > 0) {
      // GeoJSON [lng, lat] → Leaflet [lat, lng]
      return data.routes[0].geometry.coordinates.map(([lng, lat]) => [lat, lng]);
    }
    return null;
  } catch (error) {
    console.error('Error fetching OSRM route:', error);
    return null;
  }
}

export function getSegmentColor(segmentType) {
  switch (segmentType) {
    case 'to_first_pickup':
      return '#3B82F6';
    case 'trip':
      return '#22C55E';
    case 'deadhead':
      return '#F59E0B';
    default:
      return '#6B7280';
  }
}

export const USA_CENTER = [39.8283, -98.5795];
export const USA_ZOOM = 4;

/** Normalize stored coordinates to Leaflet [lat, lng][] */
export function toLeafletPath(coordinates) {
  if (!coordinates?.length) return [];
  return coordinates.map((c) => {
    if (Array.isArray(c)) return c;
    if (c?.lat != null && c?.lng != null) return [c.lat, c.lng];
    return c;
  });
}
